// Hört auf auth:required (axios 401 auf Nicht-Auth-Routen) und leitet sauber zur Login-Seite weiter.
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const DEBOUNCE_MS = 2500;

function isPublicAuthRoute(pathname) {
  const p = String(pathname || "/");
  if (p.startsWith("/login")) return true;
  if (p.startsWith("/reset-password")) return true;
  if (p.startsWith("/reset")) return true;
  if (p.startsWith("/first-password")) return true;
  if (p.startsWith("/2fa")) return true;
  return false;
}

export default function AuthRequiredListener() {
  const navigate = useNavigate();
  const location = useLocation();
  const lastHandledRef = useRef(0);

  useEffect(() => {
    const onAuthRequired = () => {
      const now = Date.now();
      if (now - lastHandledRef.current < DEBOUNCE_MS) return;
      if (isPublicAuthRoute(location.pathname)) return;
      lastHandledRef.current = now;
      try {
        sessionStorage.setItem("intended", location.pathname + location.search);
      } catch {}
      navigate("/login", { replace: true });
    };

    window.addEventListener("auth:required", onAuthRequired);
    return () => window.removeEventListener("auth:required", onAuthRequired);
  }, [navigate, location.pathname, location.search]);

  return null;
}
